export const INITIALIZE_START = "@BOOKING/INITIALIZE_START";
export const INITIALIZE_SUCCESS = "@BOOKING/INITIALIZE_SUCCESS";
export const INITIALIZE_FAILED = "@BOOKING/INITIALIZE_FAILED";
export const CLEAR = "@BOOKING/CLEAR";
export const OPEN = "@BOOKING/OPEN";

export const BOOKING_REMOVE_INVOICE_RECIPIENT =
    "BOOKING_REMOVE_INVOICE_RECIPIENT";
export const BOOKING_REMOVE_AGENT = "BOOKING_REMOVE_AGENT";
export const BOOKING_REMOVE_VEHICLE = "BOOKING_REMOVE_VEHICLE";
export const BOOKING_REMOVE_DRIVER = "BOOKING_REMOVE_DRIVER";
export const BOOKING_REMOVE_DRIVER2 = "BOOKING_REMOVE_DRIVER2";
export const BOOKING_CALCULATE_BESTRATE_SAGA =
    "BOOKING_CALCULATE_BESTRATE_SAGA";
export const BOOKING_SET_INVOICE_POSITIONS = "BOOKING_SET_INVOICE_POSITIONS";
export const BOOKING_GET_EDITING_INVOICE_POSITION_SAGA =
    "BOOKING_GET_EDITING_INVOICE_POSITION_SAGA";
export const BOOKING_SET_EDITING_INVOICE_POSITION =
    "BOOKING_SET_EDITING_INVOICE_POSITION";
export const BOOKING_CLEAR_EDITING_INVOICE_POSITION =
    "BOOKING_CLEAR_EDITING_INVOICE_POSITION";

export const BOOKING_SET_LOADING = "BOOKING_SET_LOADING";
export const BOOKING_CLEAR_LOADING = "BOOKING_CLEAR_LOADING";

export const GET_RATE_SUGGESTIONS_SAGA = "GET_RATE_SUGGESTIONS_SAGA";
